export default __webpack_public_path__ + "static/media/secondary.b1609227aff2efef8b7c57dcbf7447e5.svg";